<h1 fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" mat-dialog-title>
	<div>Recent Order Templates</div>
	<button color="primary" mat-dialog-close mat-icon-button type="button">
		<mat-icon>close</mat-icon>
	</button>
</h1>
<mat-dialog-content>
	<div fxLayout="column" fxLayoutAlign="start">
		<app-search (doSearch)="onSearchCriteriaChanged($event)" [minSearchLength]="2"></app-search>
		<div *ngIf="dataSource?.data?.length > 0 || searchCriteria.length > 0" fxLayoutAlign="end">
			<button [color]="'primary'" [matMenuTriggerFor]="menu"
					mat-button>{{'placeOrderView.showMyLastLabel' | translate}} {{numberOfTemplatesToGet}}
			</button>
			<mat-menu #menu="matMenu">
				<button (click)="setNumberOfTemplatesToGet(10)" mat-menu-item type="button">
					{{'placeOrderView.showMyLastLabel' | translate}} 10
				</button>
				<button (click)="setNumberOfTemplatesToGet(50)" mat-menu-item type="button">
					{{'placeOrderView.showMyLastLabel' | translate}} 50
				</button>
				<button (click)="setNumberOfTemplatesToGet(100)" mat-menu-item type="button">
					{{'placeOrderView.showMyLastLabel' | translate}} 100
				</button>
			</mat-menu>
		</div>
		<div *ngIf="dataSource?.data?.length > 0">
			<div class="mat-table-wrapper">
				<mat-table [dataSource]="dataSource">
					<ng-container matColumnDef="name">
						<mat-header-cell *matHeaderCellDef>
							{{'placeOrderView.templateNameColumnHeader' | translate}}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								  [attr.data-label]="'placeOrderView.templateNameColumnHeader' | translate">
							{{element?.templateName}}
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="origin">
						<mat-header-cell *matHeaderCellDef>
							{{'placeOrderView.originColumnHeader' | translate}}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								  [attr.data-label]="'placeOrderView.originColumnHeader' | translate">
							<div>
								<div>{{element?.origin?.name}}</div>
								<div>{{element?.origin?.address1}}<span
										*ngIf="element?.origin?.address2">, {{element?.origin?.address2}}</span></div>
								<div>{{element?.origin?.city}}, {{element?.origin?.state}} {{element?.origin?.zip}}</div>
							</div>
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="destination">
						<mat-header-cell *matHeaderCellDef>
							{{'placeOrderView.destinationColumnHeader' | translate}}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								  [attr.data-label]="'placeOrderView.destinationColumnHeader' | translate">
							<div>
								<div>{{element?.destination?.name}}</div>
								<div>{{element?.destination?.address1}}<span
										*ngIf="element?.destination?.address2">, {{element?.destination?.address2}}</span>
								</div>
								<div>{{element?.destination?.city}}, {{element?.destination?.state}} {{element?.destination?.zip}}</div>
							</div>
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="action">
						<mat-header-cell *matHeaderCellDef>
							{{'placeOrderView.actionsColumnHeader' | translate}}
						</mat-header-cell>
						<mat-cell *matCellDef="let element"
								  [attr.data-label]="'placeOrderView.actionsColumnHeader' | translate">
							<button [color]="'primary'" [matMenuTriggerFor]="actionMenu"
                                    mat-icon-button>
                                <mat-icon *ngIf="!element?.validTemplate" 
                                        class="icon-ivalid-order" 
                                        matTooltip="{{'orderTemplateView.invalidTemplateText' | translate}}" 
                                        matTooltipPosition="left">
                                    report_problem
                                </mat-icon>
								<mat-icon>list</mat-icon>
							</button>
							<mat-menu #actionMenu="matMenu">
								<button (click)="selectTemplate(element)" mat-menu-item *ngIf="element?.validTemplate">
									{{'placeOrderView.createOrderActionText' | translate}}
								</button>
								<button (click)="editTemplate(element)" mat-menu-item>
									{{'placeOrderView.editTemplateActionText' | translate}}
								</button>
								<button (click)="closeModal()" *ngIf="user?.inetUser?.allowTrackOrder"
										[routerLink]="['/track-order', {templateName: element?.templateName}]"
										mat-menu-item>
									{{'placeOrderView.templateTrackingActionText' | translate}}
								</button>
								<button (click)="addToCart(element)" *ngIf="user?.allowCartCheckout === true && element?.validTemplate"
										mat-menu-item>
									{{'placeOrderView.addToCartText' | translate}}
								</button>
							</mat-menu>
						</mat-cell>
					</ng-container>
					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
				</mat-table>
			</div>
		</div>
		<mat-card *ngIf="dataSource?.data?.length === 0" class="warning">
			<mat-card-content>
				<p>No recent templates found</p>
			</mat-card-content>
		</mat-card>
	</div>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
	<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
		<span>Cancel</span>
	</button>
</mat-dialog-actions>
